export default "__VITE_ASSET__F62cPCu9__ 400w, __VITE_ASSET__CMtQXZye__ 800w, __VITE_ASSET__BoHvMNTK__ 1024w";